<template>
    <modal height="auto" width="95%" :scrollable="true" @opened="onOpen" name="client-visit-add" classes="modal_default" :clickToClose="true">
    <div class="card" data-testid="visit-schedule-dialog">
        <div class="card-header">
            Naplánovat návštěvu
        </div>
        <div class="card-body">
            <div class="row m-0">
                <div class="col-sm-7">
                    <form>
                        <div class="form-inline">
                            <label class="mr-sm-2" for="doctor">K doktorovi</label>
                            <select @change="doctorChanged()" v-model="visit.planned_for" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" data-testid="visit-schedule-doctor">
                                <option value="" disabled selected>zvolit doktora</option>
                                <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                            </select>
                            <select v-model="visit.branch_id" class="form-control mr-sm-2" aria-describedby="branchHelp" id="branch" placeholder="vybrat pobočku" data-testid="visit-schedule-branch">
                                <option value="" disabled selected>zvolit pobočku</option>
                                <option v-for="row in branches" v-bind:value="row.id">{{ row.label }}</option>
                            </select>
                            <small id="doctorHelp" class="form-text text-muted"></small>
                            <label for="operation" class="mr-sm-2">za účelem</label>
                            <select @change="visitPurposeChanged($event)" v-model="visit.purpose_id" class="form-control mr-sm-2" aria-describedby="operationHelp" id="operation" data-testid="visit-schedule-purpose">
                                <option v-for="visit_purpose in visit_purposes" :value="visit_purpose.id" :data-duration="visit_purpose.duration">{{ visit_purpose.purpose }}</option>
                            </select>
                            <select v-model="visit.visit_template_id" class="form-control mr-sm-2" aria-describedby="operationHelp" id="visitTemplateSelect" :disabled="visitTemplates === false" data-testid="visit-schedule-template">
                                <option v-for="(visit_template, index) in visitTemplates" :value="visit_template.id" :selected="index === 0">{{ visit_template.name }}</option>
                                <option v-bind:value="false">bez šablony</option>
                            </select>
                            <small id="operationHelp" class="form-text text-muted"></small>
                        </div>
                        <div class="form-inline mt-2">
                            <label for="duration" class="mr-sm-2">Délka návštěvy:</label>
                            <select @change="changeSelectedWindows()" v-model="visit.duration" class="form-control mr-sm-2" id="duration" data-testid="visit-schedule-duration">
                                <option value="" disabled selected>zvolit čas</option>
                                <option :value="0">0 minut</option>
                                <option v-for="duration in 24" v-bind:value="duration" v-if="duration % 2 === 0">{{ duration*5 }} minut</option>
                            </select>
                            <label for="acute" class="mr-sm-2">
                                akutní <input v-model="visit.acute" class="form-check-input" type="checkbox" id="acute" data-testid="visit-schedule-acute">
                            </label>

                            <i title="notifikace jsou zapnuté" v-if="visit.notify" @click="changeNotification" class="fa fa-bell-o fa-2x text-success" aria-hidden="true"></i>
                            <i title="notifikace jsou VYPNUTY" v-else="" @click="changeNotification" class="fa fa-bell-slash fa-2x text-danger" aria-hidden="true"></i>
                        </div>
                        <div class="mt-2">
                            <label for="note" class="form-label">poznámka:</label><br>
                            <textarea id="note" v-model="visit.note" rows="2" class="form-control" data-testid="visit-schedule-note"></textarea>
                        </div>
                    </form>
                </div>
                <div class="col-sm-5">
                    <table class="table table_free_time">
                        <tr v-for="ft in freeTime">
                            <td>{{ ft.date }} ({{ $moment(ft.date, 'DD.MM.YYYY').format('dddd') }})</td>
                            <td>{{ $moment(windowToTime(ft.window)).format('LT') }} ({{ ft.length | windowToMinute | minutesToCsTime }})</td>
                            <td>
                                <button class="btn btn-outline-success btn-xs m-1" @click="setCalendarTo(ft.date, ft.window)">vybrat</button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <br>
            <div v-if="actual_select.selected">
                {{ moment(actual_select.date).format('dddd') }} {{ moment(actual_select.date).format('LL') }} v {{ moment(actual_select.date).format('LT') }}<br>
            </div>
            <div v-else>
                Vyberte den a čas v kalendáři
            </div>
            <div class="justify-content-between d-flex">
                <div>
                        <button @click="previousPeriod()" type="button" class="btn btn-primary" data-testid="visit-schedule-previous-week">Předchozí</button>
                </div>
                <div class="justify-content-between d-flex">
                    <div>
                        <button @click="actualPeriod" class="btn btn-primary btn-sm">aktuální týden</button>
                    </div>
                    <div>
                        <datepicker v-model="selectedDate" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" v-on:input="manualSelectDate"></datepicker>
                    </div>
                </div>
                <div>
                        <button @click="nextPeriod()" type="button" class="btn btn-primary" data-testid="visit-schedule-next-week">Následující</button>
                </div>
            </div>
            <div class="justify-content-between d-flex">
                <div>

                </div>
                <div>
                    {{ get_params.from }} - {{ get_params.to }}
                </div>
                <div>

                </div>
            </div>
            <div class="div_table">
                <table class="table table_calendar">
                    <thead>
                    <tr>
                        <th></th>
                        <th v-for="(times, index) in ((endWindow-startWindow)/windowsPerHour)" :colspan="windowsPerHour">
                            {{ (index+startHour)<10 ? '0'+(index+startHour) : (index+startHour) }}
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th v-for="(times, index) in ((endWindow-startWindow)/(windowsPerHour/2))" :colspan="(windowsPerHour/2)" class="halfHour">
                            &nbsp;
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody v-if="visits !== false" style="line-height: 1.2">
                        <template v-for="n in 7">
                          <tr>
                            <td>{{ moment(render_start_date).add(n - 1, 'days').format('dddd') }}<br><small>{{ moment(render_start_date).add(n - 1, 'days').format('L') }}</small></td>
                            <td v-for="(cell, indexTM) in (endWindow-startWindow)"
                                :data-window-id="(n - 1) + '_' +  (startWindow + cell - 1)"
                                :data-testid="'visit-schedule-slot-' + (n - 1) + '-' + (startWindow + cell - 1)"
                                :data-branch-id="getBranchIdForTd(visits[n-1][cell + startWindow - 1])"
                                v-on:mouseover="hoverWindows($event)"
                                v-on:mouseleave="unhoverWindows($event)"
                                v-on:click="prepareVisit(startWindow + cell - 1, moment(render_start_date).add(n - 1, 'days'), $event.currentTarget)"
                                :class="getRightClassForTd(visits[n-1][cell + startWindow - 1]) + ' ' + ((cell%windowsPerHour === 0) ? 'hourly' : '' ) + ' ' + ((cell%windowsPerHour === windowsPerHour/2) ? 'halfhourly' : '' )"
                                v-tooltip="{
                                  content: '<b>' + windowsHover(startWindow + cell - 1) + '</b><br>' + (visits[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(visits[n-1][cell + startWindow - 1]['visit']) : ''),
                                  placement: 'bottom-center',
                                  classes: ['info']}">
                                &nbsp;
                                <template v-for="visit in visits[n-1][cell + startWindow - 1]['visit']">
                                  <div style="position: relative;">
                                    <div class="visit_slot"
                                         style="position: absolute;"
                                         :style="{ backgroundColor: '#' + visit.visit_purpose.color, top: visit.row_slot_number*6 + 'px' }"
                                         :title="visitSlotHover(visit)">
                                    </div>
                                  </div>
                                </template>
                            </td>
                          </tr>
                          <tr>
                            <td>&nbsp;</td>
                            <template v-for="(cell, indexTM) in (endWindow-startWindow)">
                              <td v-if="visits[n-1][cell + startWindow - 1]['skipNote'] === 0 || visits[n-1][cell + startWindow - 1]['type'] !== 'work'" :colspan="visits[n-1][cell + startWindow - 1]['note'] ? visits[n-1][cell + startWindow - 1]['note']['windowsCount'] : 1"
                                  style="position: relative">
<!--                                  style="position: relative" :class="getRightClassForTd(visits[n-1][cell + startWindow - 1]) + ' ' + ((cell%windowsPerHour === 0) ? 'hourly' : '' ) + ' ' + ((cell%windowsPerHour === windowsPerHour/2) ? 'halfhourly' : '' )">-->
                                <div style="position: absolute; overflow: hidden; text-overflow: ellipsis; width: 100%; text-align: center;">
                                  {{ visits[n-1][cell + startWindow - 1]['note'] ? visits[n-1][cell + startWindow - 1]['note']['text'] : '' }}
                                </div>
                              </td>
                            </template>
                          </tr>
                        </template>
                    </tbody>
                    <tbody v-else="">
                    <tr v-for="n in 7">
                        <td>{{ moment(render_start_date).add(n - 1, 'days').format('dddd') }}<br><small>{{ moment(render_start_date).add(n - 1, 'days').format('L') }}</small></td>
                        <td v-for="(cell, indexTM) in (endWindow-startWindow)" class="blank_windows">
                            &nbsp;
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="table_overlay" v-if="visits === false || visitsPending === true">
                    <div class="" v-if="visitsPending === true">
                        <div><i class="fa fa-spinner fa-pulse fa-fw fa-4x" aria-hidden="true"></i></div>
                        <div><span class="h4"> </span></div>
                    </div>
                    <div class="text-danger"v-else-if="visits === false">
                        <div><i class="fa fa-exclamation-circle fa-4x" aria-hidden="true"></i></div>
                        <div><span class="h4">Musíte zvolit doktora</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body text-center pt-0">
            <button v-if="!visitPending" @click="postVisit(visit)" class="btn btn-success" data-testid="visit-schedule-submit">Přidat</button>
            <button class="btn btn-success disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
        </div>
    </div>
    </modal>
</template>

<script>
  import moment from 'moment'
  import apiMixin from '@/mixins'
  import Vue from 'vue'

  export default {
    data () {
      return {
        hasData: false,
        // waitForSave: false,
        calendarSize: 'week',
        startWindow: 43, // TODO změnit ze settings ordinace (záčátek standardní pracovní doby)
        endWindow: 127, // TODO změnit ze setting ordinace (konec standardní pracovní doby)
        windowsPerHour: 6, // TODO změnit ze setting ordinace (velikost "okénka")
        windowSize: 5, // TODO změnit ze setting ordinace (velikost "okénka")
        startHour: 7,
        setting: require('../../../variables.js'),
        // visits: false,
        // doctors: '',
        selectedWindow: null,
        lastDuration: '',
        visit_purposes: '',
        selected_element: null,
        visit: {
          time_window: '',
          date: '',
          client_id: null,
          planned_for: null,
          branch_id: null,
          duration: 6, // TODO změnit ze settings ordinace (výchozí délka návštěvy)
          note: '',
          acute: false,
          purpose_id: '',
          notify: true,
          visit_template_id: false
        },
        get_params: {
          from: '',
          to: '',
          doctorid: ''
        },
        get_free_time_params: {
          minimal_length: ''
        },
        start_date: '',
        end_date: '',
        begin_of_month: '',
        end_of_month: '',
        today: moment(),
        actual_select: {
          selected: false,
          time: '',
          date: '',
          window: '',
          day: ''
        },
        modalOpened: false,
        visitPurposeError: '',
        render_end_date: '',
        render_start_date: '',
        selectedDate: new Date(),
        // new
        // visits
        visits: false,
        visitsPending: false,
        visitsError: false,
        // visit
        visitPending: false,
        visitDone: false,
        visitError: false,
        // doctors
        doctors: false,
        doctorsPending: false,
        doctorsError: false,
        // branches
        branches: false,
        branchesPending: false,
        branchesError: false,
        // visit templates
        visitTemplates: false,
        // free time
        freeTimePending: false,
        freeTime: false,
        freeTimeError: false,
        preselectedWindow: false,
        preselectedDate: false
      }
    },
    props: ['opened'],
    mixins: [apiMixin],
    methods: {
      onOpen () {
        document.getElementById('doctor').focus()
      },
      windowToTime (window) {
        window = window - 1
        let hour = Math.floor(window / this.windowsPerHour)
        let minute = (window % this.windowsPerHour) * 10
        return moment().hour(hour).minute(minute)
      },
      clearLastSelect () {
        if (this.selectedWindow) {
          let element = this.selectedWindow
          for (let i = 0; i < this.lastDuration; i++) {
            element.classList.remove('selected_window')
            if (element.nextSibling === null) {
              break
            }
            element = element.nextSibling
          }
        }
      },
      setCalendarTo (date, window) {
        let selectedDate = moment(date, 'DD.MM.YYYY')
        this.hasData = false
        this.new_start_date = moment(selectedDate).startOf('isoWeek')
        if (!this.new_start_date.isSame(this.start_date, 'day')) {
          this.start_date = moment(this.new_start_date)
          this.end_date = moment(selectedDate).endOf('isoWeek')
          this.renderDates()
          this.loadCalendar()
        }
        this.preselectedWindow = window
        this.preselectedDate = moment(selectedDate)
      },
      visitPurposeChanged (event) {
        this.visit.duration = event.target.options[event.target.selectedIndex].getAttribute('data-duration')
        if (this.visit_purposes[event.target.selectedIndex].visit_normal_templates.length > 0) {
          this.visitTemplates = this.visit_purposes[event.target.selectedIndex].visit_normal_templates
          this.visit.visit_template_id = this.visitTemplates[0].id
        } else {
          this.visitTemplates = false
        }
      },
      doctorChanged () {
        if (this.visit.planned_for && this.doctors[this.visit.planned_for].default_branch_id) {
          this.visit.branch_id = this.doctors[this.visit.planned_for].default_branch_id
        }
      },
      prepareVisit (window, date, target) {
        if (target.getAttribute('data-branch-id')) {
          this.visit.branch_id = target.getAttribute('data-branch-id')
        }
        this.actual_select.window = window
        this.actual_select.selected = true
        let forTime = this.windowToTime(window)
        this.actual_select.date = moment(date).hour(forTime.hour()).minute(forTime.minute())
        this.visit.date = moment(date).format('L')
        this.visit.time_window = (window * 2) - 1

        this.clearLastSelect()
        let element = target
        this.selectedWindow = target
        this.lastDuration = (this.visit.duration / 2)
        for (let i = 0; i < this.visit.duration / 2; i++) {
          element.classList.add('selected_window')
          if (element.nextSibling === null) {
            break
          }
          element = element.nextSibling
        }
      },
      changeSelectedWindows () {
        if (this.selectedWindow) {
          let element = this.selectedWindow
          this.clearLastSelect()
          this.lastDuration = (this.visit.duration / 2)
          for (let i = 0; i < this.visit.duration / 2; i++) {
            element.classList.add('selected_window')
            if (element.nextSibling === null) {
              break
            }
            element = element.nextSibling
          }
          if (this.visit.duration === 0) {
            element.classList.add('selected_window')
          }
        }
      },
      getRightClassForTd (item) {
        let classes = item.type

        if (item.clients > 0) {
          classes += ' clients'
        }

        return classes
      },
      getBranchIdForTd (item) {
        return item.branchId
      },
      initialSet () {
        moment.locale('cs')
        this.hasData = false
        this.visit = {
          time_window: '',
          date: '',
          client_id: null,
          planned_for: null,
          branch_id: null,
          duration: 6,
          note: '',
          acute: false,
          purpose_id: '',
          notify: true,
          visit_template_id: false
        }
        this.get_params = {
          from: '',
          to: '',
          doctorid: ''
        }
        this.get_free_time_params = {
          minimal_length: ''
        }
        this.actualPeriod()
      },
      getVisits () {
        let params = {date: this.get_params.from}
        this.getWeekVisitsForDoctor(this.get_params.doctorid, params)
      },
      actualPeriod () {
        this.hasData = false
        this.start_date = moment().startOf('isoWeek')
        this.end_date = moment().endOf('isoWeek')
        this.renderDates()
        this.loadCalendar()
      },
      nextPeriod () {
        this.hasData = false
        this.start_date = this.start_date.add(1, 'weeks')
        this.end_date = this.end_date.add(1, 'weeks')
        this.renderDates()
        this.loadCalendar()
      },
      previousPeriod () {
        this.hasData = false
        this.start_date = this.start_date.subtract(1, 'weeks')
        this.end_date = this.end_date.subtract(1, 'weeks')
        this.renderDates()
        this.loadCalendar()
      },
      renderDates () {
        this.render_start_date = this.start_date
        this.render_end_date = this.end_date
        this.get_params.from = moment(this.start_date).format('DD.MM.YYYY')
        this.get_params.to = moment(this.end_date).format('DD.MM.YYYY')
      },
      loadCalendar () {
        this.get_params.doctorid = this.visit.planned_for
        if (this.visit.planned_for !== null && this.visit.planned_for !== undefined) {
          this.getVisits()
        }
        // this.renderDates()
      },
      loadFreeTime () {
        this.get_free_time_params.minimal_length = this.visit.duration / 2
        if (this.visit.planned_for !== null && this.visit.planned_for !== undefined) {
          this.getFreeTimeForDoctor(this.visit.planned_for, this.get_free_time_params)
        }
      },
      moment: function (date) {
        return moment(date)
      },
      hoverWindows (event) {
        let element = event.currentTarget
        for (let i = 0; i < this.visit.duration / 2; i++) {
          element.classList.add('hovered_window')
          if (element.nextSibling === null) {
            break
          }
          element = element.nextSibling
        }
        // event.target.nextSibling.classList.add('green')
      },
      unhoverWindows (event) {
        let element = event.currentTarget
        for (let i = 0; i < this.visit.duration / 2; i++) {
          element.classList.remove('hovered_window')
          if (element.nextSibling === null) {
            break
          }
          element = element.nextSibling
        }
        // event.target.nextSibling.classList.remove('green')
      },
      getVisitPurposes () {
        this.waitForResponse = true
        this.$http.get('visit_purpose').then(response => {
          this.visit_purposes = response.data
          let visit = this.visit
          this.visit_purposes.forEach(function (visitPurpose) {
            if (visitPurpose.default === true) {
              visit.purpose_id = visitPurpose.id
            }
          })
          this.waitForResponse = false
        }).catch(error => {
          this.visitPurposeError = error.response.data.errors
          this.waitForResponse = false
        })
      },
      init () {
        this.initialSet()
        this.visit.client_id = this.$route.params.clientid
        this.visit.planned_for = null
        this.visit.branch_id = null
        this.visit.note = ''
        this.freeTime = false
        this.getDoctors()
        this.getBranches()
        this.getVisitPurposes()
        this.selectedDate = new Date()
        this.loadCalendar()
      },
      manualSelectDate () {
        this.hasData = false
        this.start_date = moment(this.selectedDate).startOf('isoWeek')
        this.end_date = moment(this.selectedDate).endOf('isoWeek')
        this.renderDates()
        this.loadCalendar()
      },
      changeNotification () {
        this.visit.notify = !this.visit.notify
      },
      windowsHover (num) {
        let hoursFrom = Math.floor((num - 1) / 6)
        let hoursTo = Math.floor(((Number(this.visit.duration) / 2) + num - 1) / 6)
        let minutesFrom = ((num - 1) % 6) * 10
        let minutesTo = (((num - 1) + (Number(this.visit.duration) / 2)) % 6) * 10
        return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0)
      },
      windowsHoverVisits (visits) {
        let returnString = ''
        visits.forEach(function (visit) {
          returnString += '<br>' + visit.visit.timeFrom + ' - ' + visit.visit.timeTo + '<br>' + visit.visit_purpose.purpose
        })

        return returnString
      },
      visitSlotHover (visit) {
        return visit.visit_purpose.purpose
      }
    },
    watch: {
      opened (val) {
        if (val === true) {
          this.init()
        }
      },
      'visit.planned_for': function (val) {
        if (val !== null && val !== undefined) {
          this.loadCalendar()
          this.loadFreeTime()
        }
      },
      'visit.duration': function (val) {
        if (this.visit.planned_for !== null) {
          this.loadFreeTime()
        }
      },
      branchesPending (val) {
        if (val === false) {
          for (let i = 0; i < this.branches.length; i++) {
            // if (this.branches[i].default === true) {
            //   this.visit.branch_id = this.branches[i].id
            // }
          }
        }
      },
      visitsPending (val) {
        if (val === false && this.preselectedWindow !== false) {
          Vue.nextTick()
            .then(function () {
              this.prepareVisit(
                this.preselectedWindow,
                this.preselectedDate,
                document.querySelectorAll('td[data-window-id="' + (this.preselectedDate.isoWeekday() - 1) + '_' + this.preselectedWindow + '"]')[0]
              )
              this.preselectedDate = false
              this.preselectedWindow = false
            }.bind(this))
        }
      },
      preselectedDate (val) {
        if (val !== false && this.visitsPending === false) {
          Vue.nextTick()
            .then(function () {
              this.prepareVisit(
                this.preselectedWindow,
                this.preselectedDate,
                document.querySelectorAll('td[data-window-id="' + (this.preselectedDate.isoWeekday() - 1) + '_' + this.preselectedWindow + '"]')[0]
              )
              this.preselectedDate = false
              this.preselectedWindow = false
            }.bind(this))
        }
      },
      visitDone (val) {
        if (val === true) {
          this.$emit('update')
          this.visitDone = false
          this.visits = false
          this.$modal.hide('client-visit-add')
        }
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.init()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }

    .visit_slot {
      height: 6px;
      width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/views/Client/modals/AddVisit.vue?f03420a8